import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { IconModule } from './icon/icon.module';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [CommonModule, RouterModule, IconModule],
  template: `
    <nav class="bottom-nav" *ngIf="show">
      <a *ngFor="let item of navItems"
         [routerLink]="item.route"
         routerLinkActive="active"
         [attr.aria-label]="item.label">
        <app-icon [name]="item.icon" size="lg"></app-icon>
        <span class="label">{{ item.label }}</span>
      </a>
      <button class="nav-more-btn" (click)="moreClicked.emit()" aria-label="More options">
        <i class="bi bi-three-dots" aria-hidden="true"></i>
        <span class="label">More</span>
      </button>
    </nav>
  `,
  styles: [
    `
      .bottom-nav {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        height: 56px;
        background: var(--g8r-navy);
        display: flex;
        justify-content: space-around;
        align-items: center;
        box-shadow: 0 -2px 8px rgba(0,0,0,0.08);
        z-index: 1000;
      }
      .bottom-nav a, .nav-more-btn {
        background: none;
        border: none;
        color: var(--g8r-white);
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.85rem;
        flex: 1;
        padding: 0;
        cursor: pointer;
        outline: none;
        text-decoration: none;
        transition: color 0.2s;
      }
      .bottom-nav a.active, .bottom-nav a:focus {
        color: var(--g8r-accent);
      }
      .nav-more-btn { color: rgba(255,255,255,0.65); }
      .nav-more-btn.open, .nav-more-btn:active { color: #fff; }
      app-icon, .bi {
        font-size: 1.5rem;
        margin-bottom: 2px;
        display: inline-block;
      }
      .label {
        font-size: 0.75rem;
      }
      @media (min-width: 768px) {
        .bottom-nav { display: none; }
      }
    `
  ]
})
export class BottomNavComponent {
  @Input() show = false;
  @Output() moreClicked = new EventEmitter<void>();
  navItems = [
    { label: 'Dashboard', route: '/dashboard', icon: 'house' },
    { label: 'Contacts', route: '/crm/clients', icon: 'people' },
    { label: 'Matters', route: '/crm/matters', icon: 'folder' },
    { label: 'Assistant', route: '/assistant', icon: 'robot' },
  ];
}
